import { render, staticRenderFns } from "./ImageComponent.vue?vue&type=template&id=54c7ee6c&scoped=true"
import script from "./ImageComponent.vue?vue&type=script&lang=js"
export * from "./ImageComponent.vue?vue&type=script&lang=js"
import style0 from "./ImageComponent.vue?vue&type=style&index=0&id=54c7ee6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c7ee6c",
  null
  
)

export default component.exports